<template>
  <Overlay id="availability" :isOpen="openModal" @close="() => this.$emit('close')">
    <transition name="fade" mode="out-in">
<!--      <div class="success text-center" v-if="success" key="success">-->
<!--        <div class="title h3 text-center">{{ $t('Thank you for your interest in this product.') }}</div>-->
<!--        <div-->
<!--          class="h5"-->
<!--        >{{ $t("We will notify you by email as soon as it is back in stock.") }}</div>-->
<!--      </div>-->
<!--      <div v-else key="form">-->
      <div key="form" class="container mt-5">
        <div class="row justify-content-center">
          <div
            class="col-12 title h3 text-center mt-5"
          >{{ $t('This product is currently out of stock.') }}</div>
          <div
            class="col-12 wysiwyg text-center"
          >{{ $t("If you are interested in this product, please fill the form below and we'll contact you by email as soon as it is available again.") }}</div>
          <form class="form col-12" @submit.prevent="submit" novalidate>
            <base-select
              id="title"
              name="title"
              v-model="title"
              autocomplete="honorific-prefix"
              :placeholder="$t('Title') + ' *'"
              :validations="[
                        {
                          condition: $v.title.$error && !$v.title.required,
                          text: $t('Field is required.')
                        }
                      ]"
              :required="true"
              :options="[{value: 'mr', label: $t('Mr.')}, {value: 'mrs', label: $t('Mrs.')}]"
            />
            <template v-if="currentCountry == 'JP'">
              <base-input
              type="text"
              id="surname"
              name="surname"
              autocomplete="family-name"
              v-model="surname"
              @blur="$v.surname.$touch()"
              :placeholder="$t('Last name') + ' *'"
              :validations="[
                        {
                          condition: !$v.surname.required && $v.surname.$error,
                          text: $t('Field is required.')
                        }
                      ]"
              :required="true"
            />
              <base-input
              id="name"
              type="text"
              name="name"
              autocomplete="given-name"
              v-model="name"
              @blur="$v.name.$touch()"
              :placeholder="$t('First name') + ' *'"
              :validations="[
                        {
                          condition: !$v.name.required && $v.name.$error,
                          text: $t('Field is required.')
                        }
                      ]"
              :required="true"
            />
            </template>
            <template v-else>
            <base-input
              id="name"
              type="text"
              name="name"
              autocomplete="given-name"
              v-model="name"
              @blur="$v.name.$touch()"
              :placeholder="$t('First name') + ' *'"
              :validations="[
                        {
                          condition: !$v.name.required && $v.name.$error,
                          text: $t('Field is required.')
                        }
                      ]"
              :required="true"
            />
            <base-input
              type="text"
              id="surname"
              name="surname"
              autocomplete="family-name"
              v-model="surname"
              @blur="$v.surname.$touch()"
              :placeholder="$t('Last name') + ' *'"
              :validations="[
                        {
                          condition: !$v.surname.required && $v.surname.$error,
                          text: $t('Field is required.')
                        }
                      ]"
              :required="true"
            />
          </template>
            <base-input
              id="email"
              type="email"
              name="email"
              autocomplete="email"
              v-model="email"
              @blur="$v.email.$touch()"
              :placeholder="$t('E-mail address') + ' *'"
              :validations="[
                        {
                          condition: !$v.email.required && $v.email.$error,
                          text: $t('Field is required.')
                        },
                        {
                          condition: !$v.email.email && $v.email.$error,
                          text: $t('Please provide valid e-mail address.')
                        }
                      ]"
              :required="true"
            />
            <base-phone
              id="phone"
              type="text"
              name="phone"
              autocomplete="tel-national"
              v-model="phone"
              :phoneIndic="phoneIndic"
              @phoneIndic="(v) => { phoneIndic = v }"
              @blur="$v.phone.$touch()"
              :placeholder="$t('Phone N°') + ' *'"
              :validations="[
                          {
                            condition: !$v.phone.required && $v.phone.$error,
                            text: $t('Field is required.')
                          },
                          {
                            condition: $v.phoneIndic.$error && $v.phoneIndic.$error,
                            text: $t('Phone extension is required.')
                          }
                        ]"
              :required="true"
            />
            <div
              class="toggle-line"
              :class="{'-error': !$v.conditions.required && $v.conditions.$error}"
            >
              <Toggle v-model="conditions" id="conditions" :required="true"></Toggle>
              <NoSSR>
                <label
                  class="-small"
                  for="conditions"
                  v-html="$t('I accept the terms of use', {href: localizedUrl + '/page/terms'})"
                >*</label>
              </NoSSR>
              <div class="form-error">
                <label for="conditions">{{ $t('Field is required.') }}</label>
              </div>
            </div>
            <div class="toggle-line">
              <Toggle v-model="is_subscribed" id="is_subscribed"></Toggle>
              <label
                class="-small"
                for="is_subscribed"
              >{{ $t('I would like to sign up for the newsletter') }}</label>
            </div>
            <div
              class="recaptcha"
              v-html="$t('This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.' ,{hrefPrivacy: 'https://policies.google.com/privacy', hrefTerms: 'https://policies.google.com/terms'})"
            ></div>
            <CustomLoader :is-loading="loading">
              <button class="btn -block" type="submit">{{ $t('Send') }}</button>
            </CustomLoader>
          </form>
        </div>
      </div>
    </transition>
  </Overlay>
</template>

<script>
import Toggle from './form/Toggle'
import BasePhone from './form/BasePhone'
import BaseInput from '../components/form/BaseInput'
import BaseSelect from '../components/form/BaseSelect'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import { ReadyHook } from 'vue-asyncready'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import config from 'config'
import { newsletter } from '../utilities'
import { mapActions, mapGetters } from 'vuex'
import CustomLoader from './utils/CustomLoader.vue'
import Overlay from './utils/Overlay.vue'

export default {
  props: ['sku', 'openModal', 'c_notificationType'],
  name: 'ModalAvailiableForm',
  components: {
    Overlay,
    BaseInput,
    BaseSelect,
    BasePhone,
    Toggle,
    NoSSR,
    CustomLoader
  },
  mixins: [ReadyHook],
  validations: {
    title: {
      required
    },
    name: {
      required
    },
    surname: {
      required
    },
    phone: {
      required
    },
    phoneIndic: {
      required
    },
    email: {
      required,
      email
    },
    conditions: {
      sameAs: sameAs(() => true)
    }
  },
  data() {
    return {
      loading: false,
      success: false,
      title: '',
      name: '',
      surname: '',
      email: '',
      phone: '',
      message: '',
      phoneIndic: '',
      conditions: false,
      is_subscribed: false
    }
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || ''
    },
    currentUser() {
      if (this.isLoggedIn) return this.$store.state.user.current
      else {
        return null
      }
    },
    currentView() {
      const { storeCode, i18n } = currentStoreView()
      const { defaultCountry, fullLanguageName, fullCountryName } = i18n
      return {
        lang: fullLanguageName,
        country: defaultCountry,
        countryName: fullCountryName,
        storeCode
      }
    },
    currentCountry() {
      return currentStoreView().i18n.defaultCountry
    },
  },
  methods: {
    ...mapActions('feedback', ['show']),
    ...mapGetters('user', ['isLoggedIn']),
    async submit() {
      const formData = {
        civility: this.title,
        firstname: this.name,
        lastname: this.surname,
        email: this.email,
        // country: this.currentView.country,
        // lang: this.currentView.lang,
        phone: this.phoneIndic + this.phone,
        sku: this.sku,
        country: this.currentView.country,
        c_notificationType: this.c_notificationType
      }
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        await this.$store.dispatch('googleRecaptcha/isVerifiedCaptcha')
        if (!this.$store.state.googleRecaptcha.is_verified) {
          this.show({ message: 'Recaptcha error. Please try again.', context: 'error' })
        } else {
          this.loading = true
          TaskQueue.execute({
            url: config.api.url + '/api/ext/stock/notify',
            payload: {
              method: 'POST',
              mode: 'cors',
              headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            }
          })
            .then(() => {
              this.$gtm.trackEvent({
                event: 'notifyStockRequest',
                requestType: 'Stock Notification'
              })
              this.$emit('close')
              this.show({ message: "Thank you for your interest in this product.<br />We will notify you by email as soon as it is back in stock.", context: 'success', duration: 15000 })

              if (this.is_subscribed) {
                // return newsletter({ email: form.email, civility: form.civility, firstname: form.firstname, lastname: form.lastname, country: form.country })
                return newsletter({ email: formData.email, civility: formData.civility, firstname: formData.firstname, lastname: formData.lastname, country: this.currentView.country })
                  .then(response => {
                    this.$gtm.trackEvent({
                      event: 'newsletterSubscription',
                      siteLocation: 'Newsletter page'
                    })
                  })
                  .catch(error => {
                    this.show({ message: 'Newsletter registration failed', context: 'error' })
                  })
              } else {
                return null
              }
            })
            .catch(error => {
              this.show({ message: 'Notification registration failed', context: 'error' })
              console.log('Contact failed', error)
              this.loading = false
            })
        }
      }
    }
  },
  mounted() {
    this.$v.$reset()
    if (this.currentUser) {
      this.title = this.currentUser.prefix || ''
      this.name = this.currentUser.lastname || ''
      this.surname = this.currentUser.firstname || ''
      this.email = this.currentUser.email || ''
      this.phone = this.currentUser.custom_attributes.filter(i => i.attribute_code === 'phone').length ? this.currentUser.custom_attributes.filter(i => i.attribute_code === 'phone')[0].value : ''
      this.is_subscribed = this.currentUser.extension_attributes.is_subscribed || ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.modal {
  .fade-enter,
  .fade-leave-to {
    position: static;
  }
}

.modal .content .row {
  margin: 0 -1rem 3rem;
}
.modal .content .title {
  margin-bottom: 2rem;
  color: var(--zenith-component-text);
}

.wysiwyg {
  margin-bottom: 4rem;
  color: var(--zenith-component-text);
}

.form {
  color: var(--zenith-component-text);
  .toggle-line {
    text-align: left;
  }
}

.recaptcha {
  font-size: em(12);
  margin-bottom: 4rem;
  /deep/ a {
    color: var(--zenith-theme-primary);
    text-decoration: underline;
  }
}
</style>
